export default "__VITE_ASSET__CYwxn6FF__"